/**
 * Address typeahead over `publisher-address/suggest` (DB-876): the backend rejects queries shorter than
 * ADDRESS_SUGGEST_MIN_QUERY_LENGTH and caps the limit, so the UI never asks for them.
 */
/** Shortest query the typeahead searches for; the backend answers 400 for a shorter one. */
export var ADDRESS_SUGGEST_MIN_QUERY_LENGTH = 3;
/** How long the typeahead waits after the last keystroke before it asks the backend. */
export var ADDRESS_SUGGEST_DEBOUNCE_MS = 300;
/** Suggestions asked for; the backend caps the limit at 20. */
export var ADDRESS_SUGGEST_LIMIT = 10;
/**
 * @param query the text typed into the typeahead
 * @returns whether the query is long enough to be searched
 */
export var isAddressSuggestQuery = function (query) {
    return (query !== null && query !== void 0 ? query : "").trim().length >= ADDRESS_SUGGEST_MIN_QUERY_LENGTH;
};
